export const remoteWorkCopy = 'Praca zdalna';

export default {
  name: 'keyword',
  value: remoteWorkCopy,
  label: [{ highlight: true, part: remoteWorkCopy }],
  text: remoteWorkCopy,
  promoted: true
};
